import { useIsPortrait } from 'shared/hooks';
import { useTrueMobile } from 'shared/hooks/useTrueMobile';
import { useViewMode } from 'store/app/appStore';
import { useCampaignCollapsedState } from './useCampaignCollapsedState';

export const useCampaignState = () => {
  const isPortrait = useIsPortrait();
  const isTrueMobile = useTrueMobile();
  const viewMode = useViewMode();
  
  const { isCollapsed, collapsedAttributes, getCollapsedClassName } = useCampaignCollapsedState();

  return {
    isCollapsed,
    isPortrait,
    isTrueMobile,
    viewMode,
    collapsedAttributes,
    getCollapsedClassName,
  };
};
